<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img style="width: 80px; height: 64px" src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">U猫软件</p>
    <p class="address_tel_fax">
      <span>地址：湖北省武汉市武昌区三角路村福星惠誉水岸国际4号地块1楼23层1-4、 12-19室前程奋斗孵化器A11号</span>
    </p>
    <p class="email_wx">
      <span>Tel：18672757797</span>
      <span>邮箱：894958@qq.com</span>
    </p>
    <p class="copy">Copyright &copy; 2023 武汉福菊茶业有限公司</p>
    <a class="copy" href="https://beian.miit.gov.cn" target="_blank">鄂ICP备2023008417号</a>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue